export const ODB_KEYS = () => ["odb"] as const;
export const API_BASE_URL = "https://azrest.jetblue.com/od/od-service";
export type ApiResponse<T> = {
  data: T;
};
export type BaseAirport = {
  name: string;
  code: string;
  needle: string;
  jb: boolean;
  pm?: string;
  cc?: string[];
  countryCode?: string;
};
export type Region = Omit<BaseAirport, "cc"> & { cc: string[] };
export type Country = {
  code: string;
  region: string[];
  name: string;
  airports: string[];
  countrycode3: string;
};
export type CountryWithAirports<T = BaseAirport> = Omit<Country, "airports"> & {
  airports: T[];
};
export const canary = "NYC";
export type NextFetchInit = RequestInit & {
  next?: {
    revalidate?: number | false;
    tags?: readonly string[];
  };
};
